import intl from 'react-intl-universal';

import { listToMap } from '@/utils';

export const takeCareList = [
  { label: intl.get('roomstate_take_care_enum_status_done'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_status_doing'), value: 0 },
  { label: intl.get('roomstate_take_care_enum_status_todo'), value: 2 },
];
export const takeCareMap = listToMap(takeCareList);

export const contactCustomerList = [
  { label: intl.get('roomstate_take_care_enum_concat_done'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_concat_todo'), value: 0 },
];
export const contactCustomerMap = listToMap(contactCustomerList);

export const parkingDemandList = [
  { label: intl.get('roomstate_take_care_enum_parking_yes'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_parking_no'), value: 0 },
];
export const parkingDemandMap = listToMap(parkingDemandList);

export const smokeList = [
  { label: intl.get('roomstate_take_care_enum_smokeless_yes'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_smokeless_no'), value: 0 },
];
export const smokeListMap = listToMap(smokeList);

export const olderAccompanyList = [
  { label: intl.get('roomstate_take_care_enum_elder_yes'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_elder_no'), value: 0 },
];
export const olderAccompanyMap = listToMap(olderAccompanyList);

export const childAccompanyList = [
  { label: intl.get('roomstate_take_care_enum_child_yes'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_child_no'), value: 0 },
];
export const childAccompanyMap = listToMap(childAccompanyList);

export const foreignerAccompanyList = [
  { label: intl.get('roomstate_take_care_enum_foreigner_yes'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_foreigner_no'), value: 0 },
];
export const foreignerAccompanyMap = listToMap(foreignerAccompanyList);

export const roomArrangeList = [
  { label: intl.get('roomstate_take_care_enum_room_special_yes'), value: 1 },
  { label: intl.get('roomstate_take_care_enum_room_special_no'), value: 0 },
];
export const roomArrangeMap = listToMap(roomArrangeList);
